/**
 * Keeps the chat bubble (clinic-chat-bubble) clear of the bars that ride
 * along the bottom of a phone screen: the booking bar (clinic-bookbar, shown
 * with data-visible) and Horizon's sticky add-to-cart bar (data-stuck).
 *
 * Both bars slide in after their attribute flips, so the lift is worked out
 * from where a bar comes to rest (fixed, at its `bottom` offset), never from
 * where it is mid-slide. The bubble glides up by setting --clinic-chat-lift;
 * the transition is in the snippet's CSS.
 */
const GAP = 12;
const chat = document.querySelector('[data-clinic-chat]');

if (chat) {
  let queued = false;

  const shown = () =>
    [
      ...document.querySelectorAll('.clinic-bookbar[data-visible], .sticky-add-to-cart__bar[data-stuck="true"]'),
    ].filter((bar) => bar instanceof HTMLElement && bar.offsetHeight > 0);

  const sync = () => {
    queued = false;
    // offsetTop and offsetLeft ignore `translate`, so this is where the bubble
    // sits unlifted, even while it is gliding.
    const left = chat.offsetLeft;
    const right = left + chat.offsetWidth;
    const bottom = chat.offsetTop + chat.offsetHeight;
    let lift = 0;
    for (const bar of shown()) {
      const b = bar.getBoundingClientRect();
      if (left >= b.right || right <= b.left) continue;
      const offset = parseFloat(getComputedStyle(bar).bottom) || 0;
      const top = window.innerHeight - offset - bar.offsetHeight;
      lift = Math.max(lift, Math.ceil(bottom - top + GAP));
    }
    chat.style.setProperty('--clinic-chat-lift', `${lift}px`);
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  };

  // Only the bars' own show and hide attributes. Watching every node added to
  // the page re-measured the layout on each text reveal and lazy photo while
  // scrolling (QA, 17 Oct 2026).
  new MutationObserver(schedule).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['data-visible', 'data-stuck'],
  });
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
}
